export const isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
